module.exports = __webpack_public_path__ + "img/icon17.37a94c8a.png";